export default "__VITE_ASSET__BZolflf8__"